module.exports = __webpack_public_path__ + "img/icon3.106f4f7d.png";